module.exports = __webpack_public_path__ + "img/cabal.50366e22.svg";